var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_benefit",
    clipPath: "url(#clip0_10377_59942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 8.44969V2.92969H0V8.45969C0.85 8.45969 1.54 9.14969 1.54 10.0097C1.54 10.8697 0.85 11.5597 0 11.5597V17.0897H20V11.5597C19.15 11.5597 18.46 10.8697 18.46 10.0097C18.46 9.14969 19.15 8.45969 20 8.45969V8.44969ZM18.5 7.34969C17.58 7.86969 16.96 8.85969 16.96 9.99969C16.96 11.1397 17.58 12.1197 18.5 12.6497V15.5797H1.5V12.6497C2.42 12.1297 3.04 11.1397 3.04 9.99969C3.04 8.85969 2.42 7.87969 1.5 7.34969V4.41969H18.5V7.34969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5282 6.43076L6.51074 12.4482L7.5714 13.5089L13.5889 7.49142L12.5282 6.43076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.74001 8.94926C8.42001 8.94926 8.97001 8.39926 8.97001 7.71926C8.97001 7.03926 8.42001 6.48926 7.74001 6.48926C7.06001 6.48926 6.51001 7.03926 6.51001 7.71926C6.51001 8.39926 7.06001 8.94926 7.74001 8.94926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.26 11.0195C11.58 11.0195 11.03 11.5695 11.03 12.2495C11.03 12.9295 11.58 13.4795 12.26 13.4795C12.94 13.4795 13.49 12.9295 13.49 12.2495C13.49 11.5695 12.94 11.0195 12.26 11.0195Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10377_59942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefit);
export default __webpack_public_path__ + "static/media/icon_benefit.d804483fa56c387486e90b7703c31170.svg";
export { ForwardRef as ReactComponent };